/* OCC: saved cart lines + short-lived undo records. Never overwrite the legacy backup.
 * Pending add records are a durable retry barrier, not a claim that a request failed.
 */
(function(global){
  'use strict';
  const KEY='occ:cart-recovery:v2',LEGACY='occ:saved-for-later';
  const copy=value=>JSON.parse(JSON.stringify(value));
  const states=['ready','pending_remove','pending_add','review_add','restored','dismissed'];
  const positive=value=>/^\d+$/.test(String(value))&&Number.isSafeInteger(Number(value))&&Number(value)>0;
  function valid(row){
    return row&&typeof row.id==='string'&&['saved','undo'].includes(row.kind)&&states.includes(row.state)&&positive(row.variantId)&&positive(row.qty)&&
      /^[a-z0-9][a-z0-9-]{0,254}$/i.test(row.handle)&&row.properties&&typeof row.properties==='object'&&!Array.isArray(row.properties)&&
      Object.entries(row.properties).every(([key,value])=>key&&['string','number','boolean'].includes(typeof value));
  }
  function create(storage,{now=()=>Date.now(),uuid=()=>global.crypto.randomUUID()}={}){
    let memory=[],fault='';
    function read(){
      if(fault)return copy(memory);
      try{
        const raw=storage.getItem(KEY);
        if(raw!==null){
          const rows=JSON.parse(raw);
          if(!Array.isArray(rows)||!rows.every(valid))throw new Error('invalid');
          memory=rows;
        }else{
          const legacy=JSON.parse(storage.getItem(LEGACY)||'[]');
          if(!Array.isArray(legacy)||legacy.some(row=>!positive(row?.variantId)||!/^[a-z0-9][a-z0-9-]{0,254}$/i.test(row?.handle||'')||(row.qty!==undefined&&!positive(row.qty))))throw new Error('invalid');
          memory=legacy.map((row,index)=>({id:'legacy-'+index+'-'+row.variantId,kind:'saved',state:'ready',variantId:String(row.variantId),qty:Number(row.qty||1),handle:row.handle,properties:{},title:row.handle.replace(/-/g,' '),variantTitle:'',createdAt:0,legacy:true}));
        }
      }catch(_){fault='Saved-item storage is unavailable or unreadable. Existing data has not been overwritten.';}
      return copy(memory);
    }
    function write(rows){
      if(fault)return false;
      if(!rows.every(valid))return false;
      try{storage.setItem(KEY,JSON.stringify(rows));memory=copy(rows);return true;}
      catch(_){fault='Your browser could not save the change. Saved data has not been cleared.';return false;}
    }
    function list(){return read().filter(row=>row.state!=='dismissed'&&row.state!=='restored'&&!(row.kind==='undo'&&row.expiresAt<=now()&&row.state==='ready'));}
    function get(id){return read().find(row=>row.id===id);}
    function put(entry){
      const rows=read(),row={...copy(entry),id:entry.id||uuid(),createdAt:entry.createdAt||now()};
      const index=rows.findIndex(item=>item.id===row.id);
      if(index>=0)rows[index]=row;
      else{
        // Prune only expired undo/dismissed records, never active saved items or ambiguous writes.
        const retained=rows.filter(item=>!(item.kind==='undo'&&item.expiresAt<=now()&&item.state==='ready')&&!['dismissed','restored'].includes(item.state));
        if(retained.length>=200)return {ok:false,message:'Saved-item limit reached. Review existing saved items first.'};
        rows.splice(0,rows.length,...retained,row);
      }
      return write(rows)?{ok:true,row:copy(row)}:{ok:false,message:fault||'This item could not be saved.'};
    }
    function update(id,changes){const row=get(id);return row?put({...row,...changes,id}):{ok:false,message:'This saved record changed. Refresh the list.'};}
    return {list,get,put,update,warning:()=>fault,keys:[KEY,LEGACY]};
  }
  global.OCCCartRecoveryStorage={create,key:KEY};
})(typeof window==='undefined'?globalThis:window);

